<div class="container-fluid px-0">
  <now-wbsuche-lib-breadcrumb></now-wbsuche-lib-breadcrumb>

  <now-wbsuche-lib-befragung-banner></now-wbsuche-lib-befragung-banner>

  <header class="now-context-info-header" [class.now-with-image]="isDesktop$ | async">
    <div class="now-content-wrap">
      <h1 [class.no-text-break]="isPhabletOrBigger$ | async">
        Mit Ihrer Weiterbildungssuche passende Angebote finden
      </h1>
      <h2 class="visually-hidden">Weiterbildungssuche</h2>
      @if (isTabletOrBigger$ | async) {
        <p class="noTextBreak">
          {{ subtitle }}
        </p>
      }
    </div>
  </header>
</div>
